
/* === product-form.js === */
if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                if (this.form.querySelector('[name=id]')) this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('[data-cart-drawer]');
                this.submitButton = this.querySelector('[type="submit"]');
                if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                if (this.submitButton.classList.contains('notify-trigger-active')) return;

                const sectionId = this.dataset.sectionId;
                const requiredFields = document.querySelectorAll(`.custom__variant-required-${sectionId} input`);
                let formValid = true;

                requiredFields.forEach(field => {
                    if (!field.value) {
                        formValid = false;
                        field.classList.add('field--error');
                    } else {
                        field.classList.remove('field--error');
                    }
                });

                if (!formValid) {
                    this.handleErrorMessage(window.productForm.error);
                    this.submitButton.classList.remove('loading');
                    return;
                }

                let protection = false;
                if (this.submitButton.classList.contains('button__drawer--protection')) protection = true;
                if (protection && this.submitButton.classList.contains('active')) return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                if (!protection) this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const upsellProducts = window.productATCUpsells;
                let variantSelected = '';
                if (this.querySelector('.product-variant-id'))
                    variantSelected = this.querySelector('.product-variant-id').value;

                const quantityInput = document.querySelector(`input[name="quantity"][form="${this.form.getAttribute('id')}"]`);
                const quantityValue = quantityInput ? quantityInput.value : '1';

                const formData = new FormData(this.form);
                if (this.cart) {
                    if (upsellProducts && upsellProducts.length > 0) {
                        upsellProducts.forEach(product => {
                            if (product.quantityBehavior === 'equals') {
                                if (product.trigger.includes(variantSelected) && product.quantity === quantityValue) {
                                    formData.append('items[][id]', product.idToAdd);
                                    formData.append('items[][quantity]', product.quantityToAdd);
                                }
                            } else {
                                if (product.trigger.includes(variantSelected) && product.quantity <= quantityValue) {
                                    formData.append('items[][id]', product.idToAdd);
                                    formData.append('items[][quantity]', product.quantityToAdd);
                                }
                            }
                        });
                    }
                }

                const variantId = formData.get('id');
                const quantity = parseInt(formData.get('quantity')) || 1;
                const items = [{
                    id: variantId,
                    quantity: quantity,
                    properties: {}
                }];

                for (const [key, value] of formData.entries()) {
                    if (key.startsWith('properties[')) {
                        const propName = key.replace('properties[', '').replace(']', '');
                        items[0].properties[propName] = value;
                    }
                }

                const beforeEvent = new CustomEvent('cart:before-add', {
                    detail: { items },
                    cancelable: true
                });
                window.dispatchEvent(beforeEvent);

                if (items[0].properties && Object.keys(items[0].properties).length > 0) {
                    for (const [key, value] of Object.entries(items[0].properties)) {
                        if (!formData.has(`properties[${key}]`)) {
                            formData.append(`properties[${key}]`, value);
                        }
                    }
                }

                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then(response => response.json())
                    .then(response => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);

                            const isSoldOutError = response.description &&
                                (response.description.toLowerCase().includes('sold out') ||
                                 response.description.toLowerCase().includes('not available'));

                            if (isSoldOutError && !this.submitButton.classList.contains('notify-trigger-active')) {
                                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                                if (soldOutMessage) {
                                    this.submitButton.setAttribute('aria-disabled', true);
                                    const btnText = this.submitButton.querySelector('.btn-text');
                                    if (btnText) btnText.style.display = 'none';
                                    soldOutMessage.style.display = '';
                                }
                            }

                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        window.dispatchEvent(new CustomEvent('cart:added', { detail: response }));
                                        if (window.cartSettings?.openOnAdd !== false) {
                                            window.dispatchEvent(new CustomEvent('cart:open'));
                                        }
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            window.dispatchEvent(new CustomEvent('cart:added', { detail: response }));
                            if (window.cartSettings?.openOnAdd !== false) {
                                window.dispatchEvent(new CustomEvent('cart:open'));
                            }
                        }
                    })
                    .catch(() => {
                        this.handleErrorMessage(window.productForm?.networkError || 'Unable to add to cart. Please try again.');
                        this.error = true;
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (!this.error) {
                            this.submitButton.removeAttribute('aria-disabled');
                            if (protection) this.submitButton.classList.add('active');
                        }
                        if (!protection) this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;

                    if (this.errorTimer) {
                        clearTimeout(this.errorTimer);
                    }
                    this.errorTimer = setTimeout(() => {
                        this.errorMessageWrapper.setAttribute('hidden', '');
                        const isSoldOut = errorMessage.toLowerCase().includes('sold out') ||
                                         errorMessage.toLowerCase().includes('not available');
                        if (!isSoldOut && this.submitButton) {
                            this.submitButton.removeAttribute('aria-disabled');
                            this.error = false;
                        }
                    }, 5000);
                }
            }

        }
    );
}


/* === product-quantity-selector.js === */
if (typeof window.ProductQuantitySelector === 'undefined') {
  class ProductQuantitySelector {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('click', (e) => {
        const button = e.target.closest('[data-quantity-button]');
        if (!button) return;

        if (button.closest('[data-cart-drawer]') || button.closest('.cart-drawer')) {
          return;
        }

        this.handleButtonClick(e, button);
      });

      document.addEventListener('input', (e) => {
        const input = e.target;
        if (!input.matches('input[name="quantity"]')) return;

        if (input.closest('[data-cart-drawer]') || input.closest('.cart-drawer')) {
          return;
        }

        this.validateInput(input);
      });
    }

    handleButtonClick(e, button) {
      e.preventDefault();

      const container = button.closest('.product-form__quantity, .product-quantity-selector, .quantity');
      if (!container) return;

      const input = container.querySelector('input[name="quantity"]');
      if (!input) return;

      const currentValue = parseInt(input.value) || 1;
      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || Infinity;
      const step = parseInt(input.step) || 1;

      let newValue = currentValue;

      if (button.dataset.quantityButton === 'plus') {
        newValue = Math.min(currentValue + step, max);
      } else if (button.dataset.quantityButton === 'minus') {
        newValue = Math.max(currentValue - step, min);
      }

      if (newValue !== currentValue) {
        input.value = newValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.updateButtonStates(container, input);
    }

    validateInput(input) {
      const container = input.closest('.product-form__quantity, .product-quantity-selector, .quantity');
      if (!container) return;

      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || Infinity;
      let value = parseInt(input.value) || min;

      if (value < min) value = min;
      if (value > max) value = max;

      if (parseInt(input.value) !== value) {
        input.value = value;
      }

      this.updateButtonStates(container, input);
    }

    updateButtonStates(container, input) {
      const value = parseInt(input.value) || 1;
      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || Infinity;

      const minusButton = container.querySelector('[data-quantity-button="minus"]');
      const plusButton = container.querySelector('[data-quantity-button="plus"]');

      if (minusButton) {
        minusButton.disabled = value <= min;
        minusButton.classList.toggle('disabled', value <= min);
      }

      if (plusButton) {
        plusButton.disabled = value >= max;
        plusButton.classList.toggle('disabled', value >= max);
      }
    }
  }

  window.ProductQuantitySelector = new ProductQuantitySelector();
}


/* === variant-option.js === */
if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', class VariantRadios extends HTMLElement {
    constructor() {
      super();

      this.productData = null;
      this.currentVariant = null;
      this.optionIndex = parseInt(this.dataset.optionIndex) || 0;
      this.sectionId = this.dataset.section;
      this.shouldUpdateUrl = this.dataset.updateUrl !== 'false';
      this.syncGroup = this.dataset.syncGroup;
      this.instanceNumber = parseInt(this.dataset.instance) || 1;
      this.isMasterInstance = this.instanceNumber === 1;

      this.handleOptionChange = this.handleOptionChange.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.initializeComponent();
      this.bindEvents();

      if (Shopify.designMode) {
        this.setupDesignModeHandlers();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initializeComponent() {
      try {
        this.loadProductData();

        this.setInitialVariant();

        this.updateComponentState();

      } catch (error) {
        this.handleError(error);
      }
    }

    loadProductData() {
      const productScript = this.querySelector('script[type="application/json"]');
      if (!productScript) {
        const section = document.querySelector(`#shopify-section-${this.sectionId}`);
        const sectionScript = section?.querySelector('script[type="application/json"]');

        if (!sectionScript) {
          throw new Error('Product data not found - missing JSON script tag');
        }

        this.productScript = sectionScript;
      } else {
        this.productScript = productScript;
      }

      try {
        this.productData = JSON.parse(this.productScript.textContent);

        if (!this.productData || !Array.isArray(this.productData)) {
          throw new Error('Invalid product data format');
        }

      } catch (error) {
        throw new Error(`Failed to parse product data: ${error.message}`);
      }
    }

    setInitialVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');

      if (variantId) {
        const variant = this.productData.find(v => v.id.toString() === variantId);
        if (variant && variant.available) {
          this.currentVariant = variant;
          return;
        }
      }

      this.currentVariant = this.productData.find(v => v.available) || this.productData[0];
    }

    bindEvents() {
      this.addEventListener('change', this.handleOptionChange);

      document.addEventListener('variant:change', this.handleVariantChange);
    }

    handleOptionChange(event) {
      const input = event.target;
      if (!input.matches('input[type="radio"]')) return;

      const wasAlreadySelected = input.labels[0]?.classList.contains('selected');

      
      this.updateVisualState(input);

      if (wasAlreadySelected) {
        return;
      }

      if (this.isMasterInstance) {
        this.syncToOtherInstances(input.value);

        const currentSelections = this.getCurrentSelections();
        currentSelections[this.optionIndex] = input.value;

        const matchingVariant = this.findVariantByOptions(currentSelections);

        if (matchingVariant) {
          this.selectVariant(matchingVariant);
        } else {
          this.handleNoMatchingVariant(currentSelections);
        }
      } else {
        this.syncToMasterInstance(input.value);
      }
    }

    
    updateVisualState(selectedInput) {
      const selectedLabel = selectedInput.labels[0];
      if (!selectedLabel) return;

      if (selectedLabel.classList.contains('selected')) {
        return;
      }

      const allLabels = this.querySelectorAll('label');
      allLabels.forEach(label => {
        if (label !== selectedLabel) {
          label.classList.remove('selected', 'active');
        }
      });

      selectedLabel.classList.add('selected');
    }

    handleVariantChange(event) {
      const { variant, sectionId } = event.detail;

      if (sectionId !== this.sectionId) return;

      this.updateFromVariant(variant);
    }

    syncToMasterInstance(selectedValue) {
      if (!this.syncGroup) return;

      const masterInstance = document.querySelector(
        `variant-radios[data-section="${this.sectionId}"][data-sync-group="${this.syncGroup}"][data-instance="1"]`
      );

      if (masterInstance && masterInstance !== this) {
        const targetInput = masterInstance.querySelector(`input[value="${selectedValue}"]`);
        if (targetInput && !targetInput.checked) {
          targetInput.checked = true;

          const changeEvent = new Event('change', { bubbles: true });
          targetInput.dispatchEvent(changeEvent);

        }
      }
    }

    syncToOtherInstances(selectedValue) {
      if (!this.syncGroup) return;

      const otherInstances = document.querySelectorAll(
        `variant-radios[data-section="${this.sectionId}"][data-sync-group="${this.syncGroup}"]:not([data-instance="1"])`
      );

      otherInstances.forEach(instance => {
        const allLabels = instance.querySelectorAll('label');
        allLabels.forEach(label => {
          label.classList.remove('selected', 'active');
        });

        const allInputs = instance.querySelectorAll('input[type="radio"]');
        allInputs.forEach(input => {
          input.checked = false;
        });

        const targetInput = instance.querySelector(`input[value="${selectedValue}"]`);
        if (targetInput) {
          targetInput.checked = true;

          const targetLabel = targetInput.labels[0];
          if (targetLabel) {
            targetLabel.classList.add('selected');
          }

        }
      });
    }

    getCurrentSelections() {
      const selections = [];
      const masterComponents = document.querySelectorAll(`variant-radios[data-section="${this.sectionId}"][data-instance="1"]`);

      masterComponents.forEach((component) => {
        const selectedInput = component.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          const optionIndex = parseInt(component.dataset.optionIndex);
          selections[optionIndex] = selectedInput.value;
        }
      });

      return selections;
    }

    findVariantByOptions(selections) {
      return this.productData.find(variant => {
        return selections.every((value, index) => {
          if (!value) return true;

          switch (index) {
            case 0: return variant.option1 === value;
            case 1: return variant.option2 === value;
            case 2: return variant.option3 === value;
            default: return true;
          }
        });
      });
    }

    selectVariant(variant) {
      if (!variant || variant.id === this.currentVariant?.id) return;

      this.currentVariant = variant;

      this.updateSelectedOption(variant);
      this.updateAvailabilityStates();

      if (this.shouldUpdateUrl) {
        this.updateUrl(variant);
      }

      this.dispatchVariantChange(variant);
    }

    updateFromVariant(variant) {
      this.currentVariant = variant;
      this.updateSelectedOption(variant);
      this.updateAvailabilityStates();

      if (this.isMasterInstance) {
        const optionValue = this.getVariantOptionValue(variant, this.optionIndex);
        if (optionValue) {
          this.syncToOtherInstances(optionValue);
        }
      }
    }

    updateSelectedOption(variant) {
      const optionValue = this.getVariantOptionValue(variant, this.optionIndex);
      if (!optionValue) return;

      const targetInput = this.querySelector(`input[value="${optionValue}"]`);
      if (targetInput && !targetInput.checked) {
        targetInput.checked = true;
      }
    }

    getVariantOptionValue(variant, optionIndex) {
      switch (optionIndex) {
        case 0: return variant.option1;
        case 1: return variant.option2;
        case 2: return variant.option3;
        default: return null;
      }
    }

    updateAvailabilityStates() {
      const inputs = this.querySelectorAll('input[type="radio"]');
      const currentSelections = this.getCurrentSelections();

      inputs.forEach(input => {
        const testSelections = [...currentSelections];
        testSelections[this.optionIndex] = input.value;

        const matchingVariant = this.findVariantByOptions(testSelections);
        const isAvailable = matchingVariant && (matchingVariant.available || !matchingVariant.inventory_management);

        input.disabled = !isAvailable;
        const label = input.labels[0];
        if (label) {
          label.classList.toggle('disabled', !isAvailable);
          label.classList.toggle('product-variant-option__label--unavailable', !isAvailable);
        }
      });
    }

    updateComponentState() {
      if (this.currentVariant) {
        this.updateSelectedOption(this.currentVariant);
        this.updateAvailabilityStates();
      }
    }

    handleNoMatchingVariant(selections) {
      const closestVariant = this.findClosestAvailableVariant(selections);

      if (closestVariant) {
        this.selectVariant(closestVariant);
      } else {
        this.showUnavailableState();
      }
    }

    findClosestAvailableVariant(selections) {
      const availableVariants = this.productData.filter(v => v.available);

      const scoredVariants = availableVariants.map(variant => {
        let score = 0;
        selections.forEach((value, index) => {
          if (value && this.getVariantOptionValue(variant, index) === value) {
            score++;
          }
        });
        return { variant, score };
      });

      scoredVariants.sort((a, b) => b.score - a.score);
      return scoredVariants[0]?.variant || null;
    }

    showUnavailableState() {
      this.dispatchEvent(new CustomEvent('variant:unavailable', {
        bubbles: true,
        detail: { sectionId: this.sectionId }
      }));
    }

    updateUrl(variant) {
      if (!variant) return;

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);

      history.replaceState(null, '', url.toString());
    }

    dispatchVariantChange(variant) {
      const event = new CustomEvent('variant:change', {
        bubbles: true,
        detail: { 
          variant, 
          sectionId: this.sectionId,
          optionIndex: this.optionIndex
        }
      });

      document.dispatchEvent(event);

      const section = document.querySelector(`#shopify-section-${this.sectionId}`);
      if (section) {
        section.dispatchEvent(event);
      }
    }

    setupDesignModeHandlers() {
      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId === this.sectionId) {
            this.initializeComponent();
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.cleanup();
        }
      });
    }

    cleanup() {
      this.removeEventListener('change', this.handleOptionChange);
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleError(error) {
      const hasVisibleOptions = this.querySelectorAll('input[type="radio"]').length > 0;

      if (!hasVisibleOptions && Shopify.designMode) {
        const errorMessage = this.querySelector('.variant-error') || document.createElement('div');
        errorMessage.className = 'variant-error';
        errorMessage.textContent = 'Unable to load product options. Please refresh the page.';
        errorMessage.style.cssText = 'color: #d32f2f; font-size: 0.875rem; margin: 0.5rem 0;';

        if (!this.querySelector('.variant-error')) {
          this.prepend(errorMessage);
        }
      }
    }
  });

}


/* === product-variant-info.js === */
if (!customElements.get('product-variant-info')) {
  customElements.define('product-variant-info', class ProductVariantInfo extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.section;
      this.productId = this.dataset.productId;

      this.selectors = {
        price: '[data-price-container]',
        comparePrice: '[data-compare-price]',
        pricePerItem: '[data-price-per-item]',
        availability: '[data-product-availability]',
        sku: '[data-product-sku]',
        barcode: '[data-product-barcode]',
        inventory: '[data-product-inventory]',
        addToCartButton: '[data-add-to-cart-button]',
        notifyForm: '[data-notify-form]',
        atcContainer: '[data-atc-container]',
        dynamicCheckout: '[data-dynamic-checkout]',
        productForm: 'product-form',
        variantId: '[name="id"]',
        stockBlocks: '[data-stock-block]',
        stockQuantity: '[data-stock-quantity]',
        stockText: '[data-stock-text]',
        stockBar: '[data-stock-bar]'
      };

      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleVariantUnavailable = this.handleVariantUnavailable.bind(this);
    }

    connectedCallback() {
      this.bindEvents();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    bindEvents() {
      document.addEventListener('variant:change', this.handleVariantChange);
      document.addEventListener('variant:unavailable', this.handleVariantUnavailable);
    }

    handleVariantChange(event) {
      const { variant, sectionId } = event.detail;

      if (sectionId !== this.sectionId) return;

      this.updateProductInfo(variant);
    }

    handleVariantUnavailable(event) {
      const { sectionId } = event.detail;

      if (sectionId !== this.sectionId) return;

      this.showUnavailableState();
    }

    updateProductInfo(variant) {
      if (!variant) {
        return;
      }

      this.currentVariant = variant;

      try {
        this.updatePrice(variant);

        this.updateAvailability(variant);

        this.updateStockBlocks(variant);

        this.updateInfoBanners(variant);

        this.updateProductMeta(variant);

        this.updateVariantId(variant);

        this.updateAddToCartButton(variant);

        this.updateFreeProductBlocks(variant);

        this.dispatchInfoUpdated(variant);

      } catch (error) {
      }
    }

    updatePrice(variant) {
      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      const priceElement = this.querySelector('[data-price-main]');
      if (priceElement) {
        priceElement.textContent = window.Currency.formatMoney(variant.price);
      }

      const comparePriceElement = this.querySelector('[data-compare-price]');
      if (comparePriceElement) {
        if (isOnSale) {
          comparePriceElement.textContent = window.Currency.formatMoney(variant.compare_at_price);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }

      const saleBadge = this.querySelector('[data-sale-badge]');
      if (saleBadge) {
        saleBadge.style.display = isOnSale ? '' : 'none';
      }

      const pricePerItemElement = this.querySelector(this.selectors.pricePerItem);
      if (pricePerItemElement) {
        if (variant.unit_price) {
          const formattedUnitPrice = window.Currency.formatMoney(variant.unit_price);
          const unitPriceText = `${formattedUnitPrice}/${variant.unit_price_measurement.reference_unit}`;
          pricePerItemElement.textContent = unitPriceText;
          pricePerItemElement.style.display = '';
        } else {
          pricePerItemElement.style.display = 'none';
        }
      }
    }

    updateAvailability(variant) {
      const availabilityElement = this.querySelector(this.selectors.availability);

      if (availabilityElement) {
        if (variant.available) {
          availabilityElement.textContent = 'In stock';
          availabilityElement.className = 'product-availability product-availability--available';

          if (variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
            availabilityElement.textContent = `${variant.inventory_quantity} left in stock`;
          }
        } else {
          availabilityElement.textContent = 'Sold out';
          availabilityElement.className = 'product-availability product-availability--unavailable';
        }
      }

      const inventoryElement = this.querySelector(this.selectors.inventory);
      if (inventoryElement && variant.inventory_quantity !== undefined) {
        if (variant.inventory_management && variant.inventory_quantity <= 10) {
          inventoryElement.textContent = `${variant.inventory_quantity} in stock`;
          inventoryElement.style.display = '';
        } else {
          inventoryElement.style.display = 'none';
        }
      }
    }

    updateStockBlocks(variant) {
      const stockBlocks = this.querySelectorAll(this.selectors.stockBlocks);

      const blockGroups = new Map();
      stockBlocks.forEach(stockBlock => {
        const stockType = stockBlock.dataset.stockType || 'shopify';
        const stockData = stockBlock.dataset.stockVariants || '{}';
        const groupKey = `${stockType}-${stockData}`;

        if (!blockGroups.has(groupKey)) {
          blockGroups.set(groupKey, []);
        }
        blockGroups.get(groupKey).push(stockBlock);
      });

      blockGroups.forEach(blocks => {
        const stockBlock = blocks[0];
        const stockQuantityEl = stockBlock.querySelector(this.selectors.stockQuantity);
        const stockTextEl = stockBlock.querySelector(this.selectors.stockText);
        const stockBarEl = stockBlock.querySelector(this.selectors.stockBar);

        if (!stockQuantityEl || !stockTextEl || !stockBarEl) return;

        const stockType = stockBlock.dataset.stockType || 'shopify';
        const isShopifyStock = stockType === 'shopify';

        if (stockType === 'manual') {
          stockBlock.style.display = '';
          return;
        }

        if (!stockBlock._stockData) {
          try {
            stockBlock._stockData = JSON.parse(stockBlock.dataset.stockVariants || '{}');
          } catch (e) {
            stockBlock._stockData = {};
          }
        }

        const quantity = stockBlock._stockData[variant.id];
        const hasQuantity = typeof quantity === 'number' && quantity > 0;

        if (!variant.available) {
          stockBlock.style.display = 'none';
          return;
        }

        stockBlock.style.display = '';

        if (isShopifyStock && hasQuantity) {
          blocks.forEach(block => {
            const quantityEl = block.querySelector(this.selectors.stockQuantity);
            const barEl = block.querySelector(this.selectors.stockBar);

            if (quantityEl) quantityEl.textContent = quantity;
            if (barEl) {
              const limit = parseInt(barEl.dataset.limit) || 100;
              barEl.style.width = `${Math.min((quantity * 100) / limit, 100)}%`;
            }
          });
        }
      });
    }

    updateInfoBanners(variant) {
      const infoBanners = this.querySelectorAll('.product__info-banner');

      infoBanners.forEach(banner => {
        const enablePriceCondition = banner.dataset.enablePriceCondition === 'true';
        if (!enablePriceCondition) return;

        const showAlternative = banner.dataset.showAlternative === 'true';
        const minPrice = parseInt(banner.dataset.minPrice) || 0;
        const currentPrice = variant.price || 0;
        const conditionMet = currentPrice >= minPrice;

        const messageEl = banner.querySelector('.info-banner__message');
        const infoBannerDiv = banner.querySelector('.info-banner');
        if (!messageEl || !infoBannerDiv) return;

        if (conditionMet) {
          banner.style.display = '';
          messageEl.innerHTML = banner.dataset.mainMessage || '';
          const style = banner.dataset.mainStyle || 'success';
          this.updateBannerStyle(infoBannerDiv, style, banner.dataset.mainCustomBg, banner.dataset.mainCustomText);
        } else if (showAlternative) {
          banner.style.display = '';
          const remaining = minPrice - currentPrice;
          const remainingFormatted = window.Currency.formatMoney(remaining);
          const message = (banner.dataset.alternativeMessage || '').replace('[remaining]', remainingFormatted);
          messageEl.innerHTML = message;
          const style = banner.dataset.alternativeStyle || 'info';
          this.updateBannerStyle(infoBannerDiv, style, banner.dataset.altCustomBg, banner.dataset.altCustomText);
        } else {
          banner.style.display = 'none';
        }
      });
    }

    updateBannerStyle(bannerDiv, style, customBg, customText) {
      const styles = {
        success: { bg: '#D0FFE0', text: '#008454' },
        info: { bg: '#D0E7FF', text: '#004C99' },
        warning: { bg: '#FFF4CC', text: '#996600' },
        urgency: { bg: '#FFE0E0', text: '#990000' }
      };

      let bgColor, textColor;
      if (style === 'custom' && customBg && customText) {
        bgColor = customBg;
        textColor = customText;
      } else {
        const colors = styles[style] || styles.success;
        bgColor = colors.bg;
        textColor = colors.text;
      }

      bannerDiv.style.backgroundColor = bgColor;
      bannerDiv.style.color = textColor;
    }

    updateProductMeta(variant) {
      const skuElement = this.querySelector(this.selectors.sku);
      if (skuElement) {
        if (variant.sku) {
          skuElement.textContent = variant.sku;
          skuElement.closest('.product-meta__item')?.style.setProperty('display', '');
        } else {
          skuElement.closest('.product-meta__item')?.style.setProperty('display', 'none');
        }
      }

      const barcodeElement = this.querySelector(this.selectors.barcode);
      if (barcodeElement) {
        if (variant.barcode) {
          barcodeElement.textContent = variant.barcode;
          barcodeElement.closest('.product-meta__item')?.style.setProperty('display', '');
        } else {
          barcodeElement.closest('.product-meta__item')?.style.setProperty('display', 'none');
        }
      }
    }

    updateVariantId(variant) {
      const variantInputs = this.querySelectorAll(this.selectors.variantId);
      if (variantInputs.length > 0) {
        variantInputs.forEach(input => {
          input.value = variant.id;
        });
      }
    }

    updateAddToCartButton(variant) {
      const addToCartButton = this.querySelector(this.selectors.addToCartButton);
      if (!addToCartButton) return;

      const buttonText = addToCartButton.querySelector('.btn-text');
      const soldOutText = addToCartButton.querySelector('.sold-out-message');
      const notifyTriggerText = addToCartButton.querySelector('.notify-trigger-text');
      const notifyForm = this.querySelector(this.selectors.notifyForm);
      const atcContainer = this.querySelector(this.selectors.atcContainer);
      const dynamicCheckout = this.querySelector(this.selectors.dynamicCheckout);
      const hasNotify = addToCartButton.hasAttribute('data-has-notify');
      const notifyMode = addToCartButton.dataset.notifyMode;

      const isAvailable = variant.available || !variant.inventory_management;

      if (isAvailable) {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('btn--sold-out', 'notify-trigger-active');
        addToCartButton.setAttribute('aria-disabled', 'false');

        if (buttonText) buttonText.style.display = '';
        if (soldOutText) soldOutText.style.display = 'none';
        if (notifyTriggerText) notifyTriggerText.style.display = 'none';

        if (atcContainer) atcContainer.style.display = '';
        if (dynamicCheckout) dynamicCheckout.style.display = '';

        if (notifyForm) {
          notifyForm.classList.remove('notify-form-card--open');
          this.resetNotifyForm(notifyForm);
        }
      } else {
        addToCartButton.classList.add('btn--sold-out');
        if (buttonText) buttonText.style.display = 'none';
        if (dynamicCheckout) dynamicCheckout.style.display = 'none';

        if (hasNotify && notifyMode === 'button') {
          addToCartButton.disabled = false;
          addToCartButton.classList.add('notify-trigger-active');
          addToCartButton.setAttribute('aria-disabled', 'false');
          if (notifyTriggerText) notifyTriggerText.style.display = '';
          if (soldOutText) soldOutText.style.display = 'none';
          if (atcContainer) atcContainer.style.display = '';
          this.updateNotifyFormVariant(notifyForm, variant);

        } else if (hasNotify && notifyMode === 'form') {
          addToCartButton.disabled = true;
          addToCartButton.setAttribute('aria-disabled', 'true');
          addToCartButton.classList.remove('notify-trigger-active');
          if (soldOutText) soldOutText.style.display = 'none';
          if (notifyTriggerText) notifyTriggerText.style.display = 'none';
          if (atcContainer) atcContainer.style.display = 'none';
          if (notifyForm) notifyForm.classList.add('notify-form-card--open');
          this.updateNotifyFormVariant(notifyForm, variant);

        } else {
          addToCartButton.disabled = true;
          addToCartButton.setAttribute('aria-disabled', 'true');
          addToCartButton.classList.remove('notify-trigger-active');
          if (soldOutText) {
            soldOutText.style.display = '';
            soldOutText.textContent = 'Sold out';
          }
          if (notifyTriggerText) notifyTriggerText.style.display = 'none';
        }
      }
    }

    updateNotifyFormVariant(notifyForm, variant) {
      if (!notifyForm) return;

      notifyForm.dataset.variantId = variant.id;
      notifyForm.dataset.variantTitle = variant.title || '';

      const bodyInput = notifyForm.querySelector('[data-notify-body]');
      if (bodyInput) {
        bodyInput.value = 'Back in stock notification: ' + (notifyForm.dataset.productTitle || '') + ' \u2014 ' + (variant.title || '') + ' (' + (notifyForm.dataset.productHandle || '') + ')';
      }

      this.resetNotifyForm(notifyForm);
    }

    resetNotifyForm(notifyForm) {
      if (!notifyForm) return;
      const form = notifyForm.querySelector('form');
      const successMsg = notifyForm.querySelector('.notify-form-card__message--success');
      const errorMsg = notifyForm.querySelector('.notify-form-card__message--error');
      if (form) form.style.display = '';
      if (successMsg) successMsg.classList.add('hidden');
      if (errorMsg) errorMsg.classList.add('hidden');
    }

    showUnavailableState() {
      const availabilityElement = this.querySelector(this.selectors.availability);
      if (availabilityElement) {
        availabilityElement.textContent = 'Unavailable';
        availabilityElement.className = 'product-availability product-availability--unavailable';
      }

      const addToCartButton = this.querySelector(this.selectors.addToCartButton);
      const notifyForm = this.querySelector(this.selectors.notifyForm);
      const atcContainer = this.querySelector(this.selectors.atcContainer);
      const dynamicCheckout = this.querySelector(this.selectors.dynamicCheckout);

      if (addToCartButton) {
        const hasNotify = addToCartButton.hasAttribute('data-has-notify');
        const notifyMode = addToCartButton.dataset.notifyMode;
        const buttonText = addToCartButton.querySelector('.btn-text');
        const soldOutText = addToCartButton.querySelector('.sold-out-message');
        const notifyTriggerText = addToCartButton.querySelector('.notify-trigger-text');

        addToCartButton.classList.add('btn--sold-out');
        if (buttonText) buttonText.style.display = 'none';
        if (dynamicCheckout) dynamicCheckout.style.display = 'none';

        if (hasNotify && notifyMode === 'button') {
          addToCartButton.disabled = false;
          addToCartButton.classList.add('notify-trigger-active');
          if (notifyTriggerText) notifyTriggerText.style.display = '';
          if (soldOutText) soldOutText.style.display = 'none';
          if (atcContainer) atcContainer.style.display = '';
        } else if (hasNotify && notifyMode === 'form') {
          addToCartButton.disabled = true;
          if (atcContainer) atcContainer.style.display = 'none';
          if (notifyForm) notifyForm.classList.add('notify-form-card--open');
          if (soldOutText) soldOutText.style.display = 'none';
          if (notifyTriggerText) notifyTriggerText.style.display = 'none';
        } else {
          addToCartButton.disabled = true;
          if (soldOutText) {
            soldOutText.style.display = '';
            soldOutText.textContent = 'Unavailable';
          }
          if (notifyTriggerText) notifyTriggerText.style.display = 'none';
        }
      }
    }

    updateFreeProductBlocks(variant) {
      const freeProductBlocks = this.querySelectorAll('free-product-block');

      freeProductBlocks.forEach(block => {
        if (block.handleVariantUpdate) {
          block.handleVariantUpdate(variant);
        }
      });
    }

    dispatchInfoUpdated(variant) {
      const event = new CustomEvent('product:info:updated', {
        bubbles: true,
        detail: {
          variant,
          sectionId: this.sectionId,
          productId: this.productId
        }
      });

      this.dispatchEvent(event);
    }

    cleanup() {
      document.removeEventListener('variant:change', this.handleVariantChange);
      document.removeEventListener('variant:unavailable', this.handleVariantUnavailable);
    }
  });
}

